
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {carListResources} from "@/modules/CarList/resources/car-list.resources";
  import {IBalance} from "@/modules/Payment/interfaces/balance.interface";
  import {formatDateForServer} from "@/plugins/moment";
  import {IBook} from "@/interfaces/book.interface";
  import {isMobile, isMobileOnly} from "mobile-device-detect";
  import {IApp} from "@/interfaces/app.interface";
  import {KeyboardMobileHidden} from "@/plugins/keyboard-mobile-hidden";
  import {bus} from "@/plugins/bus";
  import {Barrier} from "@/modules/barriers/interfaces/barrier.interface";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import {IAppState} from "@/interfaces/app-state.interface";
  import AppCorpsFilter from "@/components/FormControls/AppCorpsFilter.vue";

  @Component({
    components: {
      AppCorpsFilter,
      AppDialog,
    },
  })
  export default class BalancePopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'payment', dialogName: 'balancePopup' };
    publicPath = process.env.VUE_APP_PUBLIC_URL;
    rulesUrl = 'https://parkingmaster.ru/payment-terms';
    popupReady = false;
    format = '-DD.MM.YYYY';
    balance = 0;
    invoiceNumber = '';
    filterDateRange = [];
    spec: IBalance.ISpecItem[] = [];
    filters: IBalance.IFilters = null;
    operations = [];
    corps = [];
    defaultCorpName = '';
    collapseValue = 'filters';
    pickerOptions = IApp.DatePickerOptions.Simple;
    displayCheckButton = false;
    userInfo = {
      email: '',
      phone: '',
    };
    statuses = {
      'Зачислено': 'accepted',
      'В обработке': 'processing',
      'Отклонено': 'rejected',
      'Возвращен': 'returned',
      "": '',
    };
    processType = {
      [IBalance.IProcessType.SetParking]:   { color: '#EE7E4E', icon: 'square-parking', },
      [IBalance.IProcessType.TerminalPay]:  { color: '',        icon: 'computer', },
      [IBalance.IProcessType.CardRejected]: { color: '#fd0000', icon: 'ban', },
      [IBalance.IProcessType.FromBank]:     { color: '#00953F', icon: 'building-columns', },
      [IBalance.IProcessType.ArrivalCard]:  { color: '#00953F', icon: 'cc-visa', },
      [IBalance.IProcessType.Correction]:   { color: '',        icon: 'wrench', },
    };

    get storeState(): IAppState { return this.$store.state; }
    get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
    get calculateSum() { return this.spec.reduce((a, b) => a + (b.tSum || 0), 0); }
    get filterNotEmpty() {
      let notEmpty = false;
      if (this.filterDateRange.length) notEmpty = true;
      if (this.corps.length > 1
        && this.filters && this.userAccess
        && this.filters.corpId !== this.userAccess.corpId) {
        notEmpty = true;
      }
      if (this.filters && this.filters.statusStr && this.filters.statusStr.length) notEmpty = true;
      return notEmpty;
    }

    created() {
      this.operations = this.storeState.book.books[IBook.BookName.balanceTypes].map(item => { return { value: item.id, label: item.name } });
      this.corps = this.storeState.book.books[IBook.BookName.Corps].map(item => { return { value: item.id, label: item.name } });

      if (isMobileOnly) {
        this.collapseValue = null;
      }

      if (this.$route.name === IApp.ROUTE_NAME.PAGE_BARRIERS) {
        bus.$emit(Barrier.BusEvents.StopLoadingBarriers);
      }
    }

    async mounted() {
      this.popupReady = false;
      this.filters = {
        corpId: this.userAccess ? this.userAccess.corpId : null,
        dateBeg: "",
        dateEnd: "",
        statusStr: null,
      };
      this.defaultCorpName = this.userAccess ? this.userAccess.corpName : '';
      await this.getBalanceInfo();
      this.popupReady = true;

      KeyboardMobileHidden();
    }

    async getBalanceInfo() {
      try {
        let params: IBalance.IFilters = this.filters;
        if (!params.dateBeg) delete params.dateBeg;
        if (!params.dateEnd) delete params.dateEnd;
        if (!params.corpId) params.corpId = this.userAccess ? this.userAccess.corpId : null;
        const { data: { result: response } } = await carListResources.httpAction({ action: IBalance.ACTION, params });
        this.balance = response.saldo;
        this.invoiceNumber = response.invoiceNumber;
        this.spec = response.spec.sort((a, b) => a.dateRpt < b.dateRpt ? 1 : -1);
        this.userInfo = response.userInfo;
        this.displayCheckButton = response.accountNumberTypeId === 2;
      }
      catch (error) { await this.$store.dispatch('handleError', error, { root: true }); }
    }

    async openUrl() {
      // await this.onClose();
      await this.$store.dispatch('dialog/openDialog', {
        blockName: 'payment',
        dialogName: 'bankAccountDocument',
        payload: {
          invoiceNumber: this.invoiceNumber
        },
      });
    }

    openRules() {
      window.open(this.rulesUrl, '_blank');
    }

    async payByCard() {
      // await this.onClose();
      await this.$store.dispatch('dialog/openDialog', {
        blockName: 'payment',
        dialogName: 'payByCardPopup',
        payload: {
          tSum: Math.abs(this.balance),
          phone: this.userInfo.phone,
          email: this.userInfo.email,
          payFromBalanceFlag: true,
          closeAction: async () => await this.getBalanceInfo(),
        }
      });
    }

    async onClose() {
      await this.closeAction();
      await this.$refs.appDialog.onClose();
    }

    async closeAction() {
      this.$store.dispatch('auth/checkToken');

      if (this.$route.name === IApp.ROUTE_NAME.PAGE_BARRIERS) {
        bus.$emit(Barrier.BusEvents.RestartLoadBarriers);
      }

      this.popupReady = false;
    }

    async onDateChange(value) {
      this.filters.dateBeg = value ? formatDateForServer(value[0], this.format) : '';
      this.filters.dateEnd = value ? formatDateForServer(value[1], this.format) : '';
      await this.getBalanceInfo();
    }

    clearDates() {
      this.filterDateRange = [];
      this.onDateChange('');
    }

    clearFilters() {
      this.filters = {
        corpId: this.userAccess ? this.userAccess.corpId : null,
        dateBeg: "",
        dateEnd: "",
        statusStr: null,
      };
      this.clearDates();
    }

    clearCorpId() {
      this.filters.corpId = this.userAccess ? this.userAccess.corpId : null;
    }
  }
